"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var MetaTabPanel = function MetaTabPanel(props) {
  var children = props.children,
    name = props.name;
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: 'meta-tabs-panel',
    supportAllEvents: true
  }, MetaTabPanel), {
    "data-name": name
  }), children);
};
(0, spaui_utils_1.setComponentMark)(MetaTabPanel, info_1["default"]);
exports["default"] = react_1["default"].memo(MetaTabPanel);